<mat-tab-group class="child-tab more" color="accent">
  <mat-tab label="Audit Log">
    <div class="col-md-12 common-table-style">
      <mat-table [dataSource]="auditSource" matSort (matSortChange)="customSortData($event)">

        <ng-container matColumnDef="Action">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Action</mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{ element.action }}
          </mat-cell>
        </ng-container>
<!-- 
        <ng-container matColumnDef="User">
          <mat-header-cell *matHeaderCellDef mat-sort-header>User</mat-header-cell>
          <mat-cell *matCellDef="let element">{{ element.createdBy }}</mat-cell>
        </ng-container> -->

        <ng-container matColumnDef="Time">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Time</mat-header-cell>
          <mat-cell *matCellDef="let element">{{ element.createdDate }}</mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="auditColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: auditColumns"></mat-row>

      </mat-table>

      <ng-container *ngIf="dataLoading">
        <div class="skeleton-box">
          <ngx-skeleton-loader [theme]="{height: '200px'}"></ngx-skeleton-loader>
        </div>
      </ng-container>

      <ng-container *ngIf="auditSource.data.length === 0 && !dataLoading">
        <div class="no-data">
          <h4>No Data Found</h4>
          <p>There are no logs available</p>
        </div>
      </ng-container>
      <mat-paginator [pageSizeOptions]="[10, 30, 50]" showFirstLastButtons></mat-paginator>

    </div>

  </mat-tab>
  <mat-tab label="Version">
    <div class="col-md-12 mt-2 common-table-style">
      <mat-table [dataSource]="versionSource" matSort (matSortChange)="customSortData($event)">

        <ng-container matColumnDef="Version">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Version</mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{ element.version }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="Created By">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Created By</mat-header-cell>
          <mat-cell *matCellDef="let element">{{ element.createdBy }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="Created Date">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Created Date</mat-header-cell>
          <mat-cell *matCellDef="let element">{{ element.createdDate }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="Action">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Action</mat-header-cell>
          <mat-cell *matCellDef="let element" class="action">
            <a mat-button color="accent" disableRipple (click)="downloadDocument(element.contractsDocumentId)"
              matTooltip="Download Document Version {{ element.version }}" disabled [matTooltipShowDelay]="300"
              [matTooltipHideDelay]="100">
              <mat-progress-spinner *ngIf="downloadLoading[element.contractsDocumentId]; else go" mode="indeterminate"
                color="accent" diameter="24"></mat-progress-spinner>
              <ng-template #go><ng-icon name="heroArrowDownTray"></ng-icon></ng-template>
            </a>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="versionColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: versionColumns"></mat-row>

      </mat-table>

      <ng-container *ngIf="dataLoading">
        <div class="skeleton-box">
          <ngx-skeleton-loader [theme]="{height: '200px'}"></ngx-skeleton-loader>
        </div>
      </ng-container>

      <ng-container *ngIf="versionSource.data.length === 0 && !dataLoading">
        <div class="no-data">
          <h4>No Data Found</h4>
          <p>There are no versions available</p>
        </div>
      </ng-container>

      <mat-paginator [pageSizeOptions]="[10, 30, 50]" showFirstLastButtons></mat-paginator>

    </div>
  </mat-tab>
</mat-tab-group>